module.exports = __webpack_public_path__ + "img/consent-based-bg-upper.b6b1b0c2.png";